import { render, staticRenderFns } from "./InforFrom.vue?vue&type=template&id=3175d462&scoped=true"
import script from "./InforFrom.vue?vue&type=script&lang=js"
export * from "./InforFrom.vue?vue&type=script&lang=js"
import style0 from "./InforFrom.vue?vue&type=style&index=0&id=3175d462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175d462",
  null
  
)

export default component.exports